import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { EventListenerServiceInstance } from '../../services/eventListener.serviceInstance';

@Component({
  selector: "app-event-listener",
  template: ``
})
export class EventListenerComponent {
  public text: String;
  isWorking: boolean = true;
  interval: any;

  @HostListener("document:click", ["$event"])
  @HostListener("document:keydown", ["$event"])
  @HostListener("document:scroll", ["$event"])

  onListenEvent(event?: any): boolean {
    return this.isWorking;
  }

  constructor(
    private eRef: ElementRef,
    private eventListenerServiceInstance: EventListenerServiceInstance
  ) {
  }
}